import { render, staticRenderFns } from "./StandaloneText.vue?vue&type=template&id=55d269e3&scoped=true&"
import script from "./StandaloneText.vue?vue&type=script&lang=js&"
export * from "./StandaloneText.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneText.vue?vue&type=style&index=0&id=55d269e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d269e3",
  null
  
)

export default component.exports